<template>
<v-layout>
  <v-flex>
<v-card>
  <v-card-title>
    <v-layout wrap align-center>
      <v-flex xs2>
        <h3 class="headline mb-0 admin-header">Endpoints</h3>
      </v-flex>
      <v-flex xs2>
        <v-btn text icon color="grey lighten-1" @click="refreshList"><v-icon>fas fa-sync</v-icon></v-btn>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          v-model="search"
          append-icon="fal fa-search"
          placeholder="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-flex>
      <v-flex xs1>
        <v-dialog v-model="deletedEndpointsDialog" max-width="1000px">
          <deleted-endpoints v-if="deletedEndpointsDialog" @endpointUnDeleted="refreshList" @endpointsUnDeleted="refreshList"></deleted-endpoints>
        </v-dialog>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="deletedEndpointsDialog=true" v-bind="attrs" v-on="on">
              <v-icon size=20 color="grey lighten-1">far fa-recycle</v-icon>
            </v-btn>
          </template>
          <span>Manage Recycle Bin</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs3><p /></v-flex>
      <v-flex xs3><v-checkbox v-model="showExternalId" label="Show ExternalId" @change="toggleExternalId"></v-checkbox></v-flex>
      <v-flex xs3 pr-5>
        <v-select label="Select statuses" :items="statuses" v-model="selectedStatuses" multiple clearable
        small-chips deletable-chips></v-select>
      </v-flex>
      <v-flex xs3 pr-5>
        <v-select label="Select monitoring groups" multiple
        :items="accessGroups" v-model="selectedAccessGroups" item-text="name" item-value="id" clearable
        small-chips>
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 2">{{ item.name }}</v-chip>
            <span
              v-if="index === 2"
              class="grey--text caption"
            >(+{{ selectedAccessGroups.length - 2 }} items)</span>
          </template>
        </v-select>
      </v-flex>
      <v-flex xs3 pr-5>
        <v-select label="Select auth statuses" multiple
        :items="credStatuses" v-model="selectedCredStatuses" clearable small-chips deletable-chips></v-select>
      </v-flex>
    </v-layout>

    </v-card-title>
        <v-dialog v-model="dialog" max-width="600px">
          <!-- <v-btn v-slot:activator="{on}" color="primary" dark class="mb-2">New Endpoint</v-btn> -->
          <v-card>
            <v-card-title>
              <span class="headline">Endpoint</span>
            </v-card-title>

            <v-card-text>
              <v-form v-model="validEp" @submit.prevent>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.hostAddress" :rules="[rules.required]" label="Host Address"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    Aliases:
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field v-model="editedItem.aliasInfo.sip" label="SIP"></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field v-model="editedItem.aliasInfo.h323" label="H323"></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field v-model="editedItem.aliasInfo.e164" label="E164"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.login" label="Login"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field type="password" v-model="editedItem.password" label="Password"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-select
                        :items="accessGroups"
                        :item-text="getAccessGroupName"
                        item-value="id"
                        v-model="editedItem.accessGroups"
                        :menu-props="{ maxHeight: '400' }"
                        label="Monitoring Groups"
                        multiple
                        disabled
                        hint="Monitoring Groups can be edited from the Monitoring Groups view"
                        persistent-hint
                      ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field disabled v-model="editedItem.externalId" label="External Id"></v-text-field>
                  </v-flex>
                  <v-flex xs10 v-if="isSU || isProfessional">
                    <span>{{editedItem.miscData}}</span>
                    <!-- <v-textarea disabled v-model="editedItem.miscDataJson" label="Miscellaneous Data"> -->
                    <!-- </v-textarea> -->
                  </v-flex>
                  <v-flex xs2 v-if="isSU">
                    <v-btn text icon @click="doCopy(editedItem.miscDataJson)"><v-icon>fas fa-copy</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-btn class="mr-4 was-orange" color="primary" outlined rounded v-if="hasMonitor(editedItem) && editedItem.accessGroups.length && editedItem.login && editedItem.password" @click.native="validateEndpoint()">Validate</v-btn>
              <v-spacer></v-spacer>
              <v-btn class="mr-4" color="primary" outlined rounded  @click.native="close">Cancel</v-btn>
              <v-btn color="primary" rounded  :disabled="!validEp" @click.native="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  <v-data-table
    :options.sync="pagination"
    :footer-props="{'items-per-page-options': rowsPerPageItems}"
    :headers="headers"
    :items="filteredEndpoints"
    :expanded.sync="expandedItems"
    :search="search"
    :loading="loading"
    v-model="selected"
    show-select
    class="endpointsList elevation-1"
  >
      <template slot="headerCell" slot-scope="props">
      <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <span>
            {{ props.header.text }}
          </span>
        </template>
        <span>
          {{ props.header.tooltip || props.header.text }}
        </span>
      </v-tooltip>
    </template>
    <template v-slot:item.id="{item}">
      <td v-if="isProfessional || isSU">{{ item.id }}</td>
    </template>
    <template v-slot:item.externalId="{item}">
      <td v-if="showExternalId">{{ item.externalId }}</td>
    </template>
    <template v-slot:item.aliases="{item}">
      <td>{{ getAliases(item.aliases) }}</td>
    </template>
    <template v-slot:item.name="{item}">
      <td>
        <router-link to="" @click.native="editItem(item)">{{ item.name }}</router-link>
      </td>
    </template>
    <template v-slot:item.hostAddress="{item}">
      <td><a :href="formatHostAddress(item)" target="_blank">{{ item.hostAddress }}</a></td>
    </template>
    <template v-slot:item.accessGroupString="{item}">
      <td>
        <v-tooltip bottom max-width="200px">
          <template v-slot:activator="{on}">
            <span v-on="on">
              {{ item.accessGroupString === 'vyopta_∞' ? '(auto)' : item.accessGroupSummary }}
            </span>
          </template>
          {{ item.accessGroupString === 'vyopta_∞' ? 'automatically added to default monitoring group' : item.accessGroupString }}
        </v-tooltip>
        </td>
    </template>
    <template v-slot:item.hasCredentials="{item}">
      <td>
          {{ item.hasCredentials ? '&check;' : 'X' }}
      </td>
    </template>
    <template v-slot:item.actions="{item}">
      <td class="actions">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn
              text
              icon
              @click="editItem(item)"
              style="height: 0px; width: 0px; padding-right:2px;"
              v-on="on"
            >
              <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn text icon @click="deleteEndpoint(item)" v-on="on"
              style="height: 0px; width: 0px;">
              <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-trash</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn text icon v-if="hasMonitor(item) && item.accessGroupSummary"
              @click="validateEndpoint(item)"  v-on="on"
              style="height: 0px; width: 0px; padding-right:2px;">
              <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-check-circle</v-icon>
            </v-btn>
          </template>
          <span>Validate</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn
              text
              icon
              v-if="hasAnyMonitor(item)"
              @click="validateEndpoint2(item)"
              v-on="on"
              style="height: 0px; width: 0px; padding-right:2px;"
            >
              <v-icon color="grey lighten-1" style="font-size: 18px;">fal fa-check-circle</v-icon>
            </v-btn>
          </template>
          <span>Validate</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn
              text
              icon
              v-if="isSU && item.accessGroupSummary"
              @click="editedId = item.id; expandItem(item)"
              v-on="on"
              style="height: 0px; width: 0px;"
            >
              <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-info-circle</v-icon>
            </v-btn>
          </template>
          <span>Realtime Data Feed</span>
        </v-tooltip>
      </td>
    </template>
      <template v-slot:expanded-item="{ headers, item}">
        <td colspan="13">
          <endpoint-rt-logs :srcIdFilter="item.id"></endpoint-rt-logs>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" type="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
  </v-data-table>
  <v-card-actions>
    <button class="btn btn-primary" @click="newItem()">New Endpoint</button>
    <v-btn v-if="selected.length" @click="changePassword()">Set Password</v-btn>
    <v-btn v-if="selected.length" @click="deleteEndpoints()">Delete</v-btn>
      <v-spacer></v-spacer>
      {{ driverStatus }}
      <v-btn text v-if="!collectorsNotFound" icon color="grey lighten-1" @click="refreshDrivers" :loading="loadingMonitors"><v-icon>fas fa-sync</v-icon></v-btn>
  </v-card-actions>
  <v-dialog v-model="pwdChangeDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Set Password for Endpoints in Monitoring Group</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="validPwd" @submit.prevent>
              <v-text-field v-model="newLogin" :rules="[rules.required]" label="Login"></v-text-field>
              <v-text-field v-model="newPassword" :rules="[rules.required]" type="password" label="Password"></v-text-field>
              <v-text-field v-model="confirmPassword" :rules="[rules.match]" type="password" label="Confirm Password"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="primary" outlined rounded  @click.native="closeBulkPasswordDialog">Cancel</v-btn>
            <v-btn color="primary" rounded  :disabled="!validPwd" @click.native="saveBulkPassword">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

              <v-dialog v-model="endpointRemoteValidationDialog" persistent width="500">
            <v-card>

                <v-card-title class="headline">{{endpointRemoteValidationStatus}}</v-card-title>
                <v-card-text>
                    <h3>{{endpointRemoteValidationMessage}}</h3>
                    <p v-if="endpointRemoteValidationMessages.length">Details:
                                <v-btn icon @click.native="showErrDetails = !showErrDetails">
                                    <v-icon>{{ showErrDetails ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
                                </v-btn>
                    </p>
                    <div v-if="showErrDetails">
                        <p v-for="(msg, i) in endpointRemoteValidationMessages" :key="i">
                            {{msg}}
                        </p>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mr-4 was-orange" color="primary" outlined rounded @click="endpointRemoteValidationDialog=false" >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
           <v-dialog
                v-model="waitDialog"
                persistent
                width="300"
                >
                <v-card
                    color="primary"
                    dark
                >
                    <v-card-text>
                    Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
</v-card>
  </v-flex>
</v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import EndpointRTLogSubPanel from '../Logs/EndpointRTLogsSubPanel.vue'
import DeletedEndpoints from './DeletedEndpoints.vue'
export default {
  components: {
    'endpoint-rt-logs': EndpointRTLogSubPanel,
    'deleted-endpoints': DeletedEndpoints
  },
  data(){
      return {
        showExternalId: false,
        selectedAccessGroups: [],
        credStatuses: [{text:'Complete', value: true}, {text:'Missing', value: false}],
        selectedCredStatuses: [],
        selectedStatuses:[],
        deletedEndpointsDialog: false,
        dialog: false,
        expandedItems: [],
        rtLogsDialog: false,
        statusFilter: '<All>',
        showErrDetails: false,
        protocols: ['Auto', 'HTTP', 'HTTPS', 'SSH'],
        editedItem: {
          id: -1,
          name: '',
          hostAddress: '',
          aliasInfo: { sip: '', h323: '', e164: ''},
          login: '',
          password: '',
          accessGroups: [],
          accessGroupString: '',
          accessGroupSummary: '',
          miscData: {}
        },
        defaultItem: {
          id: -1,
          name: '',
          hostAddress: '',
          aliasInfo: { sip: '', h323: '', e164: ''},
          login: '',
          password: '',
          accessGroups: [],
          accessGroupString: '',
          accessGroupSummary: '',
          miscData: {}
        },
        editedId: -1,
        selected: [],
        activeEndpointOriginalPassword: '',
        activeEndpointOriginal: null,
        rowsPerPageItems: [5,10,25,100,{"text":"All","value":-1}],
        search: '',
        loading: false,
        headers: [
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Host', align: 'left', sortable: true, value: 'hostAddress'},
          {text: 'Model', align: 'left', sortable: true, value: 'model'},
          {text: 'Firmware', align: 'left', sortable: true, value: 'firmware'},
          {text: 'Aliases', align: 'left', sortable: true, value: 'aliases'},
          {text: 'DN', align: 'left', sortable: true, value: 'dn'},
          {text: 'Monitoring Groups', align: 'left', sortable: true, value: 'accessGroupString'},
          {text: 'Auth', align: 'left', sortable: true, value: 'hasCredentials', tooltip: 'Are credentials present or missing?'},
          {text: 'Status', align: 'left', sortable: true, value: 'status'},
          {text: 'Status Time', align: 'left', sortable: true, value: 'statusTime'},
          {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
          {text: 'Actions', align: 'left', sortable: false, value: 'actions', width: "90px"}
        ],
        pwdChangeDialog: false,
        newLogin: '',
        newPassword: '',
        confirmPassword: '',
        validPwd: false,
        validEp: false,
        rules: {
          required: value => !!value || 'Required.',
          match: value => value === this.newPassword || 'Passwords do not match'
        },
        endpointRemoteValidationStatus: '',
        endpointRemoteValidationMessage: '',
        endpointRemoteValidationMessages: [],
        endpointRemoteValidationDialog: false,
        waitDialog: false
      }
  },

  methods: {
    getAliases(aliases) {
      if (!aliases) {
        return ''
      }
      let tokens = _.split(aliases, '/')
      return _.join(_.without(tokens, ''), ', ')
    },
    async editItem (item) {
        this.editedId = item.id
        let activeEndpoint = await this.$store.dispatch("endpoints/getEndpoint", item.id)
        if (activeEndpoint !== null) {
          this.activeEndpointOriginalPassword = activeEndpoint.password
          this.activeEndpointOriginal = Object.assign({}, activeEndpoint)
          this.editedItem = Object.assign({}, activeEndpoint)
          this.editedItem.miscDataJson = activeEndpoint.miscData ? JSON.stringify(activeEndpoint.miscData) : ""
        } else {
          this.editedItem = Object.assign({}, item)
        }
        this.dialog = true
    },
    expandItem(item) {
      this.expandedItems = [];
      this.expandedItems.push(item);
    },
    newItem () {
      this.dialog = true
    },
    close() {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedId = -1
          this.activeEndpointOriginalPassword = ''
          this.activeEndpointOriginal = null
        }, 300)
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    },
    formatHostAddress(endpoint) {
      if (!endpoint.hostAddress) {
        return ''
      }
      let protocol = endpoint.endpointProtocol
      if (protocol && (protocol !== 'Auto')) {
        protocol = protocol + '://'
      } else {
        protocol = 'https://'
      }
      return protocol + endpoint.hostAddress
    },
    async save () {
      delete this.editedItem.miscDataJson
      delete this.editedItem.accessGroupSummary
      delete this.editedItem.accessGroupString

      let success
      if (this.editedId > -1) {
        success = await this.$store.dispatch("endpoints/updateEndpoint", {endpoint: this.editedItem,
                                        pwd: (this.editedItem.password !== this.activeEndpointOriginalPassword)})
      } else {
        success = await this.$store.dispatch("endpoints/addEndpoint", this.editedItem)
      }

      if (success) {
        this.close()
        this.refreshList()
      }
    },
    async deleteEndpoint(endpoint) {
      if (confirm('Do you wish to delete ' + endpoint.name + '? '
                  + 'You will no longer be able to access the endpoint or associated data.')) {
        await this.$store.dispatch('endpoints/deleteEndpoint', endpoint)
      }
    },
    changePassword() {
      this.pwdChangeDialog = true
    },
    async deleteEndpoints() {
        if (confirm('Do you wish to delete ' + this.selected.length + ' endpoints? '
                  + 'You will no longer be able to access the endpoints or associated data.')) {
        this.loading = true;
        await this.$store.dispatch('endpoints/deleteEndpoints', this.selected);
        this.refreshList();
      }
    },
    showRTLogs(id) {
      this.editedId = id
      this.rtLogsDialog = true
    },
    closeBulkPasswordDialog() {
      this.pwdChangeDialog = false
    },
    async saveBulkPassword() {
      let endpointIds = _.map(this.selected, 'id')
      let success = await this.$store.dispatch('endpoints/setBulkPassword', { endpointIds, newLogin: this.newLogin, newPassword: this.newPassword })
      if (success) {
        this.activeAccessGroupForPwd = {}
        this.pwdChangeDialog = false
        this.selected = []
        this.refreshList()
      }
    },
    async refreshList () {
      this.loading = true
      await this.$store.dispatch('endpoints/getAllEndpointsWithStatuses')
      this.loading = false
    },
    async validateEndpoint(endpoint) {
      const target = endpoint || this.editedItem

      if (!target.id || target.id <= -1) {
        alert('Please save the endpoint before validating.')
        return
      }

      if (!endpoint && this.activeEndpointOriginal) {
        const orig = this.activeEndpointOriginal
        const current = this.editedItem
        const hasChanges = orig.name !== current.name ||
          orig.hostAddress !== current.hostAddress ||
          orig.login !== current.login ||
          orig.password !== current.password ||
          orig.endpointProtocol !== current.endpointProtocol ||
          orig.miscData !== current.miscData
        if (hasChanges) {
          alert('Note: Validation will use the saved endpoint configuration only. Your unsaved changes will not be included.')
        }
      }

      this.endpointRemoteValidationStatus = ''
      this.endpointRemoteValidationMessage = ''
      this.endpointRemoteValidationMessages = []

      this.waitDialog = true
      const result = await this.$store.dispatch("endpoints/validateEndpoint", target)
      this.waitDialog = false

      if (result && result.success) {
          this.endpointRemoteValidationStatus = "Validation was successful"
      } else {
          this.endpointRemoteValidationStatus = "Validation failed"
          this.endpointRemoteValidationMessage = result.message
      }
      this.endpointRemoteValidationMessages = result.messages || []

      this.endpointRemoteValidationDialog = true
    },
    async validateEndpoint2(endpoint) {

      if (!endpoint.login || !endpoint.password) {
        alert("Please specify login and password for the endpoint.")
        return
      }

      if (!endpoint.accessGroupSummary) {
        alert("Please add the endpoint to a monitoring group.")
        return
      }

      if (!endpoint.model) {
        if (confirm('No model detected for this endpoint. Please wait until a future polling cycle determines the model for this endpoint.')) {
          return
//          await this.validateEndpoint(endpoint)
        }
      } else {
        await this.validateEndpoint(endpoint)
      }
    },
    doCopy(val) {
      this.$copyText(val).then(() => {
        navigator.clipboard.writeText(val);
      })
    },
    async refreshDrivers() {
      this.$store.dispatch('collectors/getMonitors', true)
    },
    getMonitor(endpoint) {
      //LifesizeMonitor, DolbyMonitor, CiscoMonitor, PolycomTrioMonitor, PolycomGsHdxMonitor, PolycomX50Monitor
      var driverName = 'CiscoMonitor'

      var model = endpoint.model.toLowerCase()

      if (model.includes('x50') || model.includes('x30') || model.includes('g7500')) {
        driverName = 'PolycomX50Monitor'
      } else if (model.includes('realpresence') || model.includes('hdx')) {
        driverName = 'PolycomGsHdxMonitor'
      } else if (model.includes('trio')) {
        driverName = 'PolycomTrioMonitor'
      } else if (model.includes('dolby')) {
        driverName = 'DolbyMonitor'
      } else if (model.includes('lifesize')) {
        driverName = 'LifesizeMonitor'
      } else if (model.includes('zoom')) {
        driverName = 'ZoomRoomMonitor'
      }

      return _.find(this.monitors, (monitor) => {
          return monitor.clazz && monitor.clazz.includes(driverName)
      })
    },
    hasMonitor(endpoint) {

      if (!this.monitors || !this.monitors.length || !endpoint || !endpoint.model || !endpoint.login || !endpoint.password) {
        return false
      }

      return !!this.getMonitor(endpoint)
    },
    hasAnyMonitor(endpoint) {

      if (!this.monitors || !this.monitors.length || !endpoint) {
        return false
      }

      if (!endpoint.model) {
        return true
      }

      var monitor = this.getMonitor(endpoint)

      return !monitor || !endpoint.accessGroupSummary || !endpoint.login || !endpoint.password
    },
    getAccessGroupName(accessGroup) {
      let name = accessGroup.name;
      //console.log(name, 'vyopta_∞', 'vyopta_∞' === name, escape('vyopta_∞'), escape(name));
      if (name && ('vyopta_∞' === name)) {
        return '(auto)';
      }
      return name;
    },
    toggleExternalId: function(val) {
      if (val) {
        this.headers.unshift({text: 'ExternalId', align: 'left', sortable: true, value: 'externalId'});
      } else {
        const p = _.findIndex(this.headers, {value: 'externalId'});
        if (p > -1) {
          this.headers.splice(p, 1);
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', {
        orgContext: 'getOrgContext',
        isProfessional: 'isProfessional',
        isSU: 'isSU'
    }),
    ...mapGetters('endpoints', {
        accessGroups: 'accessGroups',
        endpoints: 'activeEndpoints',
        paginationStore: 'getPagination'
    }),
    ...mapGetters('collectors', {
      loadingMonitors: 'loadingMonitors',
      monitorsNotFound: 'monitorsNotFound',
      monitorConnectionFailed: 'monitorConnectionFailed',
      monitorsLoaded: 'monitorsLoaded',
      collectorsNotFound: 'collectorsNotFound',
      monitors: 'getMonitors'
    }),
    pagination: {
      get() {
        return this.paginationStore
      },
      set(val) {
        if (val.stored) {
          this.$store.dispatch('endpoints/setPagination', val)
        }
      }
    },
    driverStatus: {
      get() {
        if (this.collectorsNotFound) {
          return 'Collectors not found'
        } else if (this.loadingMonitors) {
          return 'Attempting to find endpoint monitors'
        } else if (this.monitorsNotFound) {
          return 'No endpoint monitors found'
        } else if (this.monitorConnectionFailed) {
          return 'Unable to get endpoint monitors (click to retry)'
        } else if (this.monitorsLoaded) {
          return 'Connected to endpoint monitors'
        }
      }
    },
    statuses: {
      get() {
        if (!this.endpoints) {
          return []
        }
        let result = _.uniq(_.map(this.endpoints, (ep) =>
            {return {
              text: ep.status === null ? '<none>' : (ep.status === '' ? '<blank>' : ep.status),
              value: ep.status }}))
        return _.sortBy(result, (item) => item.text.toLowerCase())
      }
    },
    filteredEndpoints: {
      get() {

        let finalList = this.endpoints
        if (!_.isEmpty(this.selectedStatuses)) {
          finalList = _.filter(finalList, (ep) => {
            return _.includes(this.selectedStatuses, ep.status)
          })
        }

        if (!_.isEmpty(this.selectedAccessGroups)) {
          finalList = _.filter(finalList, (ep) => {
            let agids = !ep.accessGroups ? [] : _.map(ep.accessGroups, 'id')
            return !_.isEmpty(_.intersection(this.selectedAccessGroups, agids))
          })
        }

        if (!_.isEmpty(this.selectedCredStatuses)) {
          finalList = _.filter(finalList, (ep) => {
            return _.includes(this.selectedCredStatuses, ep.hasCredentials)
          })
        }

        return finalList
      }
    }
  },
  watch: {
    orgContext: async function(val) {

      this.loading = true
      await this.$store.dispatch('endpoints/getAllAccessGroups')
      await this.$store.dispatch('endpoints/getAllEndpointsWithStatuses')
      this.loading = false
      if (!this.collectorsNotFound) {
        this.$store.dispatch('collectors/getMonitors')
      }
    }
  },
  async created () {
    if (this.isProfessional || this.isSU) {
      this.headers.unshift({text: 'Id', align: 'left', sortable: true, value: 'id'})
    }
    this.loading = true
    await this.$store.dispatch('endpoints/getAllAccessGroups')
    await this.$store.dispatch('endpoints/getAllEndpointsWithStatuses')
    this.loading = false
    if (!this.collectorsNotFound) {
      this.$store.dispatch('collectors/getMonitors')
    }
  }
}
</script>
<style scoped>
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 11px;
  }
  .actions .v-btn {
    margin: 0 8px;
  }
</style>
